import { SearchIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { cn } from "@/lib/utils";
import { SadieSimulatorEntry } from "@/types";

// Marks the turn a job search ran for. Production never shows the worker a
// search, it only answers once one is done, so this sits outside the bubbles.
export const SadieSimulatorSearchNote = ({
  className,
  search,
}: {
  className?: string;
  search: NonNullable<SadieSimulatorEntry["search"]>;
}) => (
  <Column className={cn("gap-0.5", className)}>
    <Row className="items-center gap-1.5">
      <SearchIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" />
      <Text className="text-xs font-normal text-slate-500">
        {search.summary}
      </Text>
    </Row>
    {search.editsReplaced ? (
      <Text className="pl-5 text-xs font-normal text-amber-700">
        Your prompt edits touched a section the search changed, so the fresh
        render replaced them.
      </Text>
    ) : null}
  </Column>
);
